// extracted by mini-css-extract-plugin
export default {"editorStyling":"text-block-module--editor-styling--65331","animationWrapper":"text-block-module--animationWrapper--c378f"};